import SearchOffOutlined from "@mui/icons-material/SearchOffOutlined";
import { Box, Card, CardActions, CardContent, CardHeader, Divider, Skeleton, Stack, Typography } from "@mui/material";

export default function EmptyCard({
  text,
  secondaryText,

  icon,

  isLoading,
}) {
  return (
    <>
      {isLoading ? (
        <Card className="empty-card" sx={{ cursor: "default" }}>
          <CardHeader
            avatar={<Box className="farm-county-card-avatar"></Box>}
            title={<Skeleton variant="text" width="40%" sx={{ fontSize: "20px" }} />}
          />
          <Divider />
          <CardContent>
            <Stack direction="row" spacing={4} alignItems="center" justifyItems="center">
              <Stack direction="column" spacing={1}>
                <Skeleton variant="text" width="40px" sx={{ fontSize: "20px" }} />
                <Skeleton variant="text" width="50px" sx={{ fontSize: "18px" }} />
              </Stack>
              <Stack direction="column" spacing={1}>
                <Skeleton variant="text" width="40px" sx={{ fontSize: "20px" }} />
                <Skeleton variant="text" width="100px" sx={{ fontSize: "18px" }} />
              </Stack>
            </Stack>
          </CardContent>
          <Divider />
          <CardActions>
            <Stack direction="row" spacing={0} sx={{ flexWrap: "wrap", rowGap: 1, columnGap: 2 }}>
              <Skeleton variant="text" width="130px" sx={{ fontSize: "18px" }} />
              <Skeleton variant="text" width="80px" sx={{ fontSize: "18px" }} />
              <Skeleton variant="text" width="100px" sx={{ fontSize: "18px" }} />
            </Stack>
          </CardActions>
        </Card>
      ) : (
        <Card className="empty">
          <CardContent>
            <Stack direction="column" justifyContent="center" alignItems="center" sx={{ minHeight: "1.85in" }}>
              {icon || <SearchOffOutlined fontSize="large" color="primary" sx={{ fontSize: "20pt", mb: 2 }} />}
              <Typography variant="h5" sx={{ display: "inline" }}>
                {text || "No data is available yet"}
              </Typography>

              {Boolean(secondaryText) && (
                <Typography variant="body1" sx={{ display: "inline" }}>
                  {secondaryText}
                </Typography>
              )}
            </Stack>
          </CardContent>
        </Card>
      )}
    </>
  );
}
